import { TextControl } from '@wordpress/components';

const InspectorTextControl = ( { label, value, onChange } ) => (
	<TextControl label={ label } value={ value } onChange={ onChange } />
);

export default InspectorTextControl;
